const accordion = async function () {
    if ( document.querySelector(".accordion") ) {
        const accordions = document.querySelectorAll(".accordion");
        
        accordions.forEach(accordion => {
           const items = accordion.querySelectorAll(".accordion__item");
           
           const closeAccordions = (exception = null) => {
               items.forEach(item => {
                  if ( item.querySelector(".accordion__item__content") && exception !== item ) {
                      $(item.querySelector(".accordion__item__content")).slideUp();
                      item.querySelector(".accordion__item__btn").classList.remove('rotate-45');
                  }
               });
           }
           
           items.forEach(item => {
               if ( 
                   item.querySelector(".accordion__item__btn") &&
                   item.querySelector(".accordion__item__content")
               ) {
                   const content = item.querySelector(".accordion__item__content"),
                       btn = item.querySelector(".accordion__item__btn");
                   
                   // init
                   btn.classList.add('transform', 'transition-transform');
                   
                   if ( item.classList.contains("accordion__item-open") ) {
                       btn.classList.add('rotate-45');
                   }
                   else {
                       $(content).slideUp();
                   }
                   
                   // toggle content
                   btn.addEventListener("click", () => {
                       closeAccordions(item);
                       

                        if ( !btn.classList.contains('rotate-45') ) {
                            $(content).slideDown();
                            btn.classList.add('rotate-45');

                            setTimeout(() => {            
                                scroll({
                                    top: $(content).parent('.accordion__item').offset().top - 145,
                                    behavior: "smooth"
                                });
                            }, 500);
                        }
                        else {
                            $(content).slideUp();
                            btn.classList.remove('rotate-45');
                        }
                   })
               }
           });
        });
    }
}

export const init = accordion;